import { motion, useReducedMotion } from "framer-motion";

const Progress = ({
  percents,
  stroke = "currentColor",
  emptyStroke = stroke,
  emptyStrokeOpacity = 0.25,
  duration = 0.5,
  delay = 0,
  size = 100,
  strokeWidth = 12,
}) => {
  const shouldReduceMotion = useReducedMotion();
  const radius = 45;
  const circumference = Math.ceil(2 * Math.PI * radius);
  const fillPercents = Math.abs(
    Math.ceil((circumference / 100) * (percents - 100))
  );

  const transition = {
    duration: shouldReduceMotion ? 0 : duration,
    delay: shouldReduceMotion ? 0 : delay,
  };

  const variants = {
    hidden: { strokeDashoffset: circumference, transition },
    show: { strokeDashoffset: fillPercents, transition },
  };

  return (
    <div className="neeto-molecules-progress__circle">
      <div
        className="neeto-molecules-progress__circle-wrapper"
        style={{ height: size }}
      >
        <svg
          height={size}
          version="1.1"
          viewBox="0 0 100 100"
          width={size}
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            {...{ strokeWidth }}
            className="circle"
            cx="50"
            cy="50"
            fill="transparent"
            r={radius}
            stroke={emptyStroke}
            strokeOpacity={emptyStrokeOpacity}
          />
        </svg>
        <svg
          height={size}
          viewBox="0 0 100 100"
          width={size}
          style={{
            position: "absolute",
            transform: "rotate(-90deg)",
            overflow: "visible",
            top: 0,
          }}
        >
          <motion.circle
            {...{ stroke, strokeWidth, variants }}
            animate="show"
            cx="50"
            cy="50"
            fill="transparent"
            initial="hidden"
            r={radius}
            strokeDasharray={circumference}
            strokeDashoffset={fillPercents}
          />
        </svg>
      </div>
    </div>
  );
};

export default Progress;
